import axios from "axios";
import React, { useEffect, useState } from "react";
import DOMPurify from 'dompurify';
import {Link, useParams} from 'react-router-dom';

const VisaDetails = () => {
    const { slug } = useParams();
    const [visaDetail,setVisaDetail] = useState([]);
    const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    useEffect(() =>{
        if (!slug) return;
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_VISA_DETAIL;
        axios.get(`${apiBaseUrl}${Url}/${slug}`)
            .then(response => setVisaDetail(response.data))
            .catch(error => console.error("Error fetching API",error));
    },[]);

    const [visaTypes,setVisaTypes] = useState([]);
    useEffect(() =>{
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_VISA_TYPE;
        axios.get(`${apiBaseUrl}${Url}`)
            .then(response => setVisaTypes(response.data))
            .catch(error => console.error("Error fetching API",error));
    },[]);
    return (
        <main className="main">

            <div className="site-breadcrumb" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/breadcrumb/01.jpg)`}}>
                <div className="container">
                    <h2 className="breadcrumb-title">{visaDetail?.name}</h2>
                    <ul className="breadcrumb-menu">
                        <li>
                            <Link to={'/'} className="nav-link">হোম</Link>
                        </li>
                        <li className="active">{visaDetail?.name}</li>
                    </ul>
                </div>
            </div>




            <div className="visa-single py-100">
                <div className="container">
                    <div className="row g-4">
                        <div className="col-lg-8">
                            <div className="visa-details">
                                <div className="mb-30">
                                    <img className={'img-fluid'} src={`${backendBaseUrl}${visaDetail?.image}`} alt="" />
                                </div>
                                <div className="content">
                                    <h3 className="mb-20">{visaDetail?.name}</h3>
                                    <div className="site-heading mb-3" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(visaDetail?.long_description) }}>

                                    </div>
                                    {/*<div className="row mb-20">
                                        <div className="col-md-4">
                                            <div className="visa-single-item">
                                                <img src="assets/img/icon/agent.svg" alt="" />
                                                <h5>Fill In The Required Form</h5>
                                                <p>There are many variations of passages available but the majority
                                                    suffered.</p>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="visa-single-item">
                                                <img src="assets/img/icon/document.svg" alt="" />
                                                <h5>Submit Your Original Documents</h5>
                                                <p>There are many variations of passages available but the majority
                                                    suffered.</p>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="visa-single-item">
                                                <img src="assets/img/icon/visa.svg" alt="" />
                                                <h5>Get The Visa Resource Material</h5>
                                                <p>There are many variations of passages available but the majority
                                                    suffered.</p>
                                            </div>
                                        </div>
                                    </div>*/}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="visa-sidebar">
                                <div className="widget">
                                    <h4 className="title fw-bold">ভিসার ধরন</h4>
                                    <div className="visa-list">
                                        {visaTypes.map((visaType, index) => {
                                            return (
                                                <Link className="list-item text-decoration-none" to={`/visa/${visaType.slug}`}>
                                                    <span>{visaType?.name}</span>
                                                    <i className="far fa-angle-double-right"></i>
                                                </Link>
                                            );
                                        })}



                                    </div>
                                </div>
                                {/*<div className="widget">
                                    <h4 className="title">Downloads</h4>
                                    <div className="download-list">
                                        <a href="#" className="theme-btn"><span className="far fa-file-pdf"></span> Visa
                                            Application Form</a>
                                        <a href="#" className="theme-btn"><span
                                            className="far fa-file-pdf"></span> Immigration Form</a>
                                    </div>
                                </div>*/}
                                {/*<div className="visa-banner"  style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/visa/banner.jpg)`}}>*/}
                                {/*    <div className="banner-content">*/}
                                {/*        <span>Get Visa Service</span>*/}
                                {/*        <h1>Feel Free To Contact Us</h1>*/}
                                {/*        <a href="#" className="theme-btn2">Contact Us<i*/}
                                {/*            className="fas fa-circle-arrow-right"></i></a>*/}
                                {/*    </div>*/}
                                {/*</div>*/}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </main>
    );
}

export default VisaDetails;